import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";
import { useSelector } from "react-redux";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import currencyFormat from "../../utils/common/CurrencyFormat";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  IconButton,
  Autocomplete,
  Tooltip,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { billingdata } from "../../assets/Griddata"; // Import dataset
import { LICENSE_API_01 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";

function LicenseDetails() {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const theme = useTheme();
  const styles = useStyles(theme);

  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [details, setDetails] = useState("");

  console.log("detailsdetailsdetails", details);
  const goToPage = () => {
    navigate("/AddLocations");
  };

  const handleSearchChange = (event) => {
    // Update searchText when typing in TextField
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetching company details with specified parameters
        const result = await externalgetApi(LICENSE_API_01, "get", {
          COMPCODE,
          STS: CON_STATUS_ACTIVE,
        });

        if (result) {
          setDetails(result); // Assuming the result contains Table1, Table2, Table3
        } else {
          setError("No data found");
        }
        setIsLoading(false);
      } catch (err) {
        setError(err.message || "Error fetching data");
      }
    };

    fetchData();
  }, [COMPCODE, CON_STATUS_ACTIVE]);

  // Function to format datetime string to date (YYYY-MM-DD)
  const formatDate = (datetime) => {
    if (!datetime) return "";
    const date = new Date(datetime);
    return date.toISOString().split("T")[0];
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      //   onClick: (GROUPCODE) => handleItemClick(GROUPCODE, "Edit"),
    },
  ];
  const groupedByPackageCode = (details.Table4 || []).reduce((acc, row) => {
    if (!acc[row.PACKAGECODE]) {
      acc[row.PACKAGECODE] = [];
    }
    acc[row.PACKAGECODE].push(row);
    return acc;
  }, {});

  const rows = filteredData
    ? filteredData.map((item, index) => ({
        id: index + 1,
        GROUPCODE: item.GROUPCODE,
        GROUPNAME: item.GROUPNAME,
      }))
    : [];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Account</Link>
                <Link underline="none">License Details </Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.box_container_add}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={styles.col_title}>
              <Typography variant="title" align="left">
                License Details
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box p={1} sx={styles.box_accordian}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography style={{ fontWeight: "bold" }}>
              License Details
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {(details.Table1 || []).map((row, index) => (
              <Grid container spacing={1} key={index} pl={2}>
                <Grid
                  item
                  lg={3}
                  md={3}
                  xs={12}
                  sm={3}
                  sx={{
                    py: 1,
                    mt: 2,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.text.secondary,
                      fontWeight: 600,
                    }}
                    align="left"
                  >
                    License Key{" "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={9}
                  md={9}
                  xs={12}
                  sm={9}
                  sx={{
                    background: theme.palette.background.default,
                    py: 1,
                    boxShadow: 1,
                    mt: 2,
                  }}
                >
                  {row.LICENSEKEY}
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={3}
                  xs={12}
                  sm={3}
                  sx={{
                    py: 1,
                    mt: 2,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.text.secondary,
                      fontWeight: 600,
                    }}
                    align="left"
                  >
                    Billing Cycle{" "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={9}
                  md={9}
                  xs={12}
                  sm={9}
                  sx={{
                    background: theme.palette.background.default,
                    py: 1,
                    boxShadow: 1,
                    mt: 2,
                  }}
                >
                  Monthly
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={3}
                  xs={12}
                  sm={3}
                  sx={{
                    py: 1,
                    mt: 2,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.text.secondary,
                      fontWeight: 600,
                    }}
                    align="left"
                  >
                    Issue Date{" "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={9}
                  md={9}
                  xs={12}
                  sm={9}
                  sx={{
                    background: theme.palette.background.default,
                    py: 1,
                    boxShadow: 1,
                    mt: 2,
                  }}
                >
                  {formatDate(row.LICENSEDATE)}
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={3}
                  xs={12}
                  sm={3}
                  sx={{
                    py: 1,
                    mt: 2,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.text.secondary,
                      fontWeight: 600,
                    }}
                    align="left"
                  >
                    Last Renewal Date{" "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={9}
                  md={9}
                  xs={12}
                  sm={9}
                  sx={{
                    background: theme.palette.background.default,
                    py: 1,
                    mt: 2,
                    boxShadow: 1,
                  }}
                >
                  {formatDate(row.LICENSRENEWDATE)}
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={3}
                  xs={12}
                  sm={3}
                  sx={{
                    py: 1,
                    mt: 2,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.text.secondary,
                      fontWeight: 600,
                    }}
                    align="left"
                  >
                    Expiry Date{" "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={9}
                  md={9}
                  xs={12}
                  sm={9}
                  sx={{
                    background: theme.palette.background.default,
                    py: 1,
                    mt: 2,
                    boxShadow: 1,
                  }}
                >
                  {formatDate(row.EXTENDDATE)}
                </Grid>
              </Grid>
            ))}
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography style={{ fontWeight: "bold" }}>
              {" "}
              Package Information
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper} sx={{ mt: 0 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}> Package</TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      {" "}
                      Package Value
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      {" "}
                      Add on Value
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      {" "}
                      Gross value
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      Net Value
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(details.Table4 || []).map((row) => (
                    <TableRow key={row.PACKAGECODE}>
                      <TableCell
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {row.PACKAGENAME}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {currencyFormat(row.LICENSEVALUE)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {currencyFormat(row.ADDONVALUE)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {currencyFormat(row.GROSSVALUE)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {currencyFormat(row.NETTVALUE)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <Typography style={{ fontWeight: "bold" }}>
              Package License Information
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper} sx={{ mt: 0 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      License Type Name
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      No of Units
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      Rate
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      Gross Value
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      Net Value
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(details.Table3 || []).map((row, index) => (
                    <TableRow key={index}>
                      <TableCell
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {row.LICENSETYPENAME}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {row.NOOFUNITS}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {currencyFormat(row.RATE)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {currencyFormat(row.GROSSVALUE)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {currencyFormat(row.NETVALUE)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4-content"
            id="panel4-header"
          >
            <Typography style={{ fontWeight: "bold" }}>
              Package Add-on Information
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper} sx={{ mt: 0 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ background: theme.palette.background.paper }}>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Addon Name
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      No of Units
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      Rate
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      Gross Value
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      Net Value
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(details.Table2 || []).map((row, index) => (
                    <TableRow key={index}>
                      <TableCell
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {row.ADDONNAME}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {row.NOOFUNITS}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {currencyFormat(row.RATE)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {currencyFormat(row.GROSSVALUE)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          ...styles.AI_tablecell,
                        }}
                      >
                        {currencyFormat(row.NETVALUE)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </Box>
    </div>
  );
}

export default LicenseDetails;
